import React from 'react';
import PropTypes from 'prop-types';
import { Backdrop, Button } from '@mui/material';

const PlannerLoadErrorModal = ({ loadError, onDismiss /* , onRetry */ }) => {
  console.log(loadError);
  return (
    <Backdrop
      sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
      open>
      <div style={{ color: 'white', padding: '20px', textAlign: 'center' }}>
        <h2>Could not load planned week</h2>
        {/* <Button
          variant="contained"
          color="primary"
          style={{ margin: '0 6px ' }}
          onClick={onRetry}>
          Try again
        </Button> */}
        <Button
          variant="contained"
          style={{ margin: '0 6px ' }}
          onClick={onDismiss}>
          Dismiss
        </Button>
      </div>
    </Backdrop>
  );
};

PlannerLoadErrorModal.propTypes = {
  loadError: PropTypes.string.isRequired,
  onDismiss: PropTypes.func.isRequired,
  // onRetry: PropTypes.func.isRequired,
};

export default PlannerLoadErrorModal;
